import { logRequestFailure } from '@/helpers/request-outcome'
import { api } from '@/helpers/apiClient'
import { eventReviewsDtoSchema, eventReviewTargetDtoSchema, type EventReviewsDto, type EventReviewTargetDto } from '@lib/dto/vendor-review.dto'
import type { WriteVendorReviewInput } from '@lib/input/vendor-review.input'
import type { IVendorReviewService } from '@/types/VendorReviewService.types'

/** An event's reviews of the companies that worked it (docs/vendor-growth.spec.md, "Reviews"), by its couple and its planner. */
class VendorReviewService implements IVendorReviewService {
  async forEvent(eventId: string): Promise<EventReviewsDto> {
    try {
      return await api.get(`/events/${eventId}/reviews`, eventReviewsDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to read an event’s reviews', { eventId }, error)
      throw error
    }
  }

  /** Write a review of a company that worked the event, or change one not yet published. */
  async write(eventId: string, vendorId: string, input: WriteVendorReviewInput): Promise<EventReviewTargetDto> {
    try {
      return await api.put(`/events/${eventId}/reviews/${vendorId}`, input, eventReviewTargetDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to send a review', { eventId, vendorId }, error)
      throw error
    }
  }
}

export const vendorReviewService = new VendorReviewService()
